<ng-container #headerRef></ng-container>
<ng-container #globalBannerRef></ng-container>

<ng-container *ngIf="!hostContext">
  <ng-container *ngIf="isStandalone; else defaultOutlet">
    <main id="main" class="hdms-main">
      <ng-container *ngTemplateOutlet="outletRef"></ng-container>
    </main>
  </ng-container>
</ng-container>

<ng-template #defaultOutlet>
  <div>
    <ng-container *ngTemplateOutlet="outletRef"></ng-container>
  </div>
</ng-template>

<ng-template #outletRef>
  <router-outlet
    #outlet
    shrdUicPagePreloader
    (activate)="onOutletActivate(outlet)"
    
  ></router-outlet>
  <ng-container #globalToastContainerRef></ng-container>
</ng-template>

<ng-container #footerRef></ng-container>
